import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import axios from "axios";
import "../styles/multipleCyberRiskReport.css";
import "../styles/responsive.css";
import LocationService from "../utils/LocationService";
import Header from "../components/ui/Header";
import { translations } from "../utils/translations";
import MainForm from "./MultipleForm/MultipleCyberRiskForm";
import {
  multipleDomainScanRequest,
  multipleDomainScanReset,
} from "../redux/actions/multipleDomainActions";
import MultipleFormModal from "./MultipleForm/MultipleFormModal/MultipleFormModal";

const MultipleCyberRiskReport = () => {
  const oemPartner = sessionStorage.getItem("user");
  const oemId = JSON.parse(oemPartner)?.oemPartner?.id;
  const dispatch = useDispatch();
  const { loading, data, error, success } = useSelector(
    (state) => state.multipleDomain
  );
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      language: "eng",
      firstName: "",
      lastName: "",
      email: "",
      domains: [{ value: "" }], // ✅ FIX: use object format
      agree: false,
    },
    mode: "onChange",
  });

  const [displayLanguage, setDisplayLanguage] = useState(() =>
    LocationService.getLanguageFromStorage()
  );
  const [userLocation, setUserLocation] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [submittedDomains, setSubmittedDomains] = useState([]);
  const [dbVersion, setDbVersion] = useState(null);
  const watchedValues = watch();

  const currentLang = displayLanguage;
  const t = translations[currentLang];

  // Initialize location and language from cached data
  useEffect(() => {
    LocationService.getLocation()
      .then((location) => {
        setUserLocation(location.country);
        setDisplayLanguage("eng");
        setValue("language", "eng");
      })
      .catch(() => {});
  }, [setValue]);

  // Fetch DB version from public versions endpoint
  useEffect(() => {
    axios.get("/versions/latest")
      .then((res) => {
        if (res.data?.version) setDbVersion(res.data.version);
      })
      .catch(() => {});
  }, []);

  const handleLanguageChange = (value) => {
    setValue("language", value);
    const locationData = {
      country: userLocation || "Unknown",
      language: value,
    };
    localStorage.setItem("userLocation", JSON.stringify(locationData));
  };

  const onSubmit = (data) => {
    const domains = data.domains
      .map((d) => d.value.trim())
      .filter((domain) => domain !== "");

    const payload = {
      email: data.email,
      domains: domains,
      language: data.language,
      firstName: data.firstName,
      lastName: data.lastName,
      oemId: oemId,
      appVersion: dbVersion || null,
    };

    setSubmittedDomains(domains);
    dispatch(multipleDomainScanRequest(payload));
  };

  // Show modal when status is 200
  useEffect(() => {
    if (success && data?.status === 200) {
      setShowSuccessModal(true);
    }
  }, [success, data]);

  const handleModalClose = () => {
    setShowSuccessModal(false);
    setValue("firstName", "");
    setValue("lastName", "");
    setValue("email", "");
    setValue("domains", [{ value: "" }]);
    setValue("agree", false);
    dispatch(multipleDomainScanReset());
  };

  // Reset Redux state on component unmount
  useEffect(() => {
    return () => {
      dispatch(multipleDomainScanReset());
    };
  }, [dispatch]);

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div className="mb-4">
          <div>
            <Header translations={t} />
            <MainForm
              register={register}
              handleSubmit={handleSubmit(onSubmit)}
              errors={errors}
              loading={loading}
              translations={t}
              isValid={isValid}
              onLanguageChange={handleLanguageChange}
              control={control}
              watch={watch}
              dbVersion={dbVersion}
            />
          </div>
        </div>
      </div>

      {/* <Modal show={showSuccessModal} onHide={handleModalClose} centered>
        <Modal.Header className="px-2 py-1">
          <Modal.Title className="fs-5">
            Report Generation in Progress
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We’ve started generating your domain report for the following
            domains:
          </p>
          <ul>
            {submittedDomains.map((domain, index) => (
              <li key={index}>{domain}</li>
            ))}
          </ul>
          <p>
            This may take a few moments. You’ll receive an email notification
            with the reports as soon as they’re ready.
          </p>
        </Modal.Body>
        <div className="w-100 text-center mb-3">
          <Button
            className="px-3 py-1 fs-6 border-0"
            style={{ background: "linear-gradient(135deg, #1e40af, #3b82f6)" }}
            onClick={handleModalClose}
          >
            Got it
          </Button>
        </div>
      </Modal> */}

      <MultipleFormModal showSuccessModal={showSuccessModal} submittedDomains={submittedDomains} handleModalClose={handleModalClose} responseData={data} />
    </div>
  );
};

export default MultipleCyberRiskReport;
